module.exports = __webpack_public_path__ + "img/eggpot-game-enterance.60f2ead4.webp";